import type { AuthContextProps } from '../Auth.types';
import AuthContext from '../context/AuthContext';
import { useContext } from 'react';

const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};

export default useAuth;
